import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Disclaimer() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-472" data-mp="1axdwtxzysjmy">Aviso Médico</h1>
        <p className="muted" data-id="element-473" data-mp="1axnixahw26nd">Última actualización: 29 de mayo de 2026</p>

        <h2 data-id="element-474" data-mp="e7dae5n2if8t">Información general</h2>
        <p data-id="element-475" data-mp="e8eka6sckvoy">
          El contenido de lipolaserbeverlyhills.com tiene fines exclusivamente
          informativos y educativos. No constituye asesoramiento médico,
          diagnóstico ni recomendación de tratamiento. Todo procedimiento es
          realizado y supervisado por el Dr. Naveed N. Nosrati MD.
        </p>

        <h2 data-id="element-476" data-mp="rzt3oeq62ywj">No es una relación médico-paciente</h2>
        <p data-id="element-477" data-mp="3rmjdd44cyvrx">
          Acceder a este sitio o solicitar una consulta privada NO establece una
          relación médico-paciente. Dicha relación solo se establece tras una
          consulta presencial formal con el especialista.
        </p>

        <h2 data-id="element-478" data-mp="20mvcma8g5tpf">Resultados individuales</h2>
        <p data-id="element-479" data-mp="1vobvqo8pn83x">
          Los resultados estéticos varían significativamente entre cada
          paciente. Factores que influyen incluyen:
        </p>
        <ul data-id="element-480" data-mp="1qwah4vo2l5aq">
          <li data-id="element-481" data-mp="1qvr2bntpux0x">Anatomía individual y composición corporal</li>
          <li data-id="element-482" data-mp="1lzabumz1o6ko">Edad y elasticidad de la piel</li>
          <li data-id="element-483" data-mp="1lwedwyn75hw8">Estilo de vida y hábitos alimenticios</li>
          <li data-id="element-484" data-mp="1h0gycujrcfki">Cumplimiento del protocolo post-procedimiento</li>
          <li data-id="element-485" data-mp="1cxu30jnvocik">Salud general y condiciones preexistentes</li>
        </ul>
        <p data-id="element-486" data-mp="1cwj1kqhwngum">
          Las imágenes mostradas representan casos reales con consentimiento
          expreso. NO son garantía de resultados similares para cada paciente.
        </p>

        <h2 data-id="element-487" data-mp="1317ixx3dlphl">Lipolaser y procedimientos estéticos</h2>
        <p data-id="element-488" data-mp="32cid2e8zxidf">
          El Lipolaser es un procedimiento estético no quirúrgico para contorno
          corporal. NO es un tratamiento para la obesidad ni un sustituto de
          dieta y ejercicio. Su candidatura debe ser evaluada individualmente
          por un profesional médico calificado.
        </p>

        <h2 data-id="element-489" data-mp="10fqdjw8sh3d3">Riesgos y consideraciones</h2>
        <p data-id="element-490" data-mp="10grmnv68vfs6">
          Como con cualquier procedimiento estético, existen riesgos potenciales
          que serán discutidos detalladamente durante su consulta privada. Es
          responsabilidad del paciente proporcionar información médica completa
          y precisa al equipo clínico.
        </p>

        <h2 data-id="element-491" data-mp="1efrc351kzype">Cumplimiento regulatorio</h2>
        <p data-id="element-492" data-mp="1jdsvxs6u021x">
          Lipolaser Los Angeles LLC opera bajo las normas y
          regulaciones del Estado de California y cumple con HIPAA en el manejo
          de información médica protegida.
        </p>

        <h2 data-id="element-493" data-mp="19fde6ftp2553">Búsqueda de atención médica</h2>
        <p data-id="element-494" data-mp="19ebr1czels70">
          Si está considerando un procedimiento estético, consulte siempre con
          un profesional médico certificado. No retrase la búsqueda de atención
          médica basándose únicamente en información encontrada en internet.
        </p>

        <h2 data-id="element-495" data-mp="2c7zbnn2xkv4i">Contacto</h2>
        <p data-id="element-496" data-mp="2c77h8fl2l3ft">
          Para consultas médicas específicas, solicite su consulta privada o
          contáctenos en{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-497" data-mp="27962g6uofqa5">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </> : <>
        <h1 data-id="element-498" data-mp="2h7c20ht0gkbu">Medical Disclaimer</h1>
        <p className="muted" data-id="element-499" data-mp="2h8dcak27d2si">Last updated: May 29, 2026</p>

        <h2 data-id="element-500" data-mp="1th7yeaftokku">General information</h2>
        <p data-id="element-501" data-mp="1tij3qeox20e2">
          The content of lipolaserbeverlyhills.com is for informational and
          educational purposes only. It does not constitute medical advice,
          diagnosis, or treatment recommendation. All procedures are performed
          and supervised by Dr. Naveed N. Nosrati MD.
        </p>

        <h2 data-id="element-502" data-mp="1xhi2fhk210x2">No physician-patient relationship</h2>
        <p data-id="element-503" data-mp="19t8m2v5m15db">
          Accessing this site or requesting a private consultation does NOT
          establish a physician-patient relationship. Such relationship is only
          established after a formal in-person consultation with the specialist.
        </p>

        <h2 data-id="element-504" data-mp="1ifteupfroecl">Individual results</h2>
        <p data-id="element-505" data-mp="1nfz9mehc2gyw">
          Aesthetic results vary significantly between each patient. Factors
          that influence outcomes include:
        </p>
        <ul data-id="element-506" data-mp="1seiyamnba6uy">
          <li data-id="element-507" data-mp="1se0rwx6xqc9b">Individual anatomy and body composition</li>
          <li data-id="element-508" data-mp="1x7lpwp8j368i">Age and skin elasticity</li>
          <li data-id="element-509" data-mp="1x8dehg3pk3pa">Lifestyle and eating habits</li>
          <li data-id="element-510" data-mp="226eyq4cve92c">Adherence to post-procedure protocol</li>
          <li data-id="element-511" data-mp="227zozhs5j5ue">General health and pre-existing conditions</li>
        </ul>
        <p data-id="element-512" data-mp="265nrp70362wu">
          Images shown represent real cases with express consent. They are NOT a
          guarantee of similar results for every patient.
        </p>

        <h2 data-id="element-513" data-mp="2g5odr0pcax4q">Lipolaser and aesthetic procedures</h2>
        <p data-id="element-514" data-mp="2g3bumk7uigq3">
          Lipolaser is a non-surgical aesthetic procedure for body contouring.
          It is NOT a treatment for obesity nor a substitute for diet and
          exercise. Your candidacy must be individually evaluated by a qualified
          medical professional.
        </p>

        <h2 data-id="element-515" data-mp="e97615tng4pa">Risks and considerations</h2>
        <p data-id="element-516" data-mp="9gmbu36tzpl8">
          As with any aesthetic procedure, there are potential risks that will
          be discussed in detail during your private consultation. It is the
          patient's responsibility to provide complete and accurate medical
          information to the clinical team.
        </p>

        <h2 data-id="element-517" data-mp="x79yxvpbilsd">Regulatory compliance</h2>
        <p data-id="element-518" data-mp="x689gm7k1wr4">
          Lipolaser Los Angeles LLC operates under the rules and
          regulations of the State of California and complies with HIPAA in the
          handling of protected health information.
        </p>

        <h2 data-id="element-519" data-mp="nancx3l99oor">Seeking medical care</h2>
        <p data-id="element-520" data-mp="i9zc5q785thc">
          If you are considering an aesthetic procedure, always consult with a
          certified medical professional. Do not delay seeking medical care
          based solely on information found on the internet.
        </p>

        <h2 data-id="element-521" data-mp="32y5b4dq6p68s">Contact</h2>
        <p data-id="element-522" data-mp="331t1x548vejt">
          For specific medical inquiries, request your private consultation or
          contact us at{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-523" data-mp="1z1l26g73hii7">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </>;
  return <LegalLayout data-id="element-524" data-mp="1l1acvhlfobz5">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-525" data-mp="1q39eon1iz0tz">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-526" data-mp="1bc0ghpjk4758">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-527" data-mp="1bafpub0d58cn">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-528" data-mp="1g53cs5fpxup4">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-529" data-mp="12cn9r4mthwo7">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-530" data-mp="17ax3dasw8p7p">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-531" data-mp="xcr3eyqndt5h" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-532" data-mp="xebx6m55182a">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-533" data-mp="dsip9vvsd16m">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-534" data-mp="9qou234d0pdu">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-535" data-mp="wpbk3wklqa32">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}